import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { PageLayout } from '@src/common/PageLayout';

const PageName = styled.h1({
  fontSize: '36px',
  fontWeight: 600,
  paddingTop: '20px',
  textAlign: 'left',
  fontFamily: '$heading',
  color: '$primary1',
  margin: 'auto',
});

const Heading = styled.p({
  fontWeight: 500,
  paddingTop: '5px',
  paddingBottom: '18px',
  textAlign: 'left',
  fontFamily: '$primary',
});

export const TinRegistrationStatusHeader = () => {
  return (
    <React.Fragment>
      <PageLayout>
        <PageName id="Status-headerTitle">
          Tax Identification Number (TIN) registration status
        </PageName>
        <Heading id="Status-headerContent">
          If you have submitted your TIN registration, a claim—or both—to
          UnitedHealthcare, you can check on the progress of your submissions
          here. Claims can be processed after your TIN submission is approved.
        </Heading>
      </PageLayout>
    </React.Fragment>
  );
};

TinRegistrationStatusHeader.propTypes = {};

TinRegistrationStatusHeader.defaultProps = {};
